/**
 * Numéro de version affiché à l'utilisateur (pied de barre latérale) et envoyé
 * à Sentry comme `release` (`main.tsx`).
 *
 * ⚠️ CE FICHIER N'EST PAS LA SOURCE UNIQUE, malgré ce qu'a longtemps affirmé
 * cette docstring. Le numéro vit à DEUX endroits, sur deux chaînes qui ne se
 * croisent jamais :
 *
 *   · `frontend/src/version.ts`   → la barre latérale et la release Sentry
 *   · `frontend/package.json`     → la clé de cache du Service Worker
 *                                   (`vite.config.ts`, `swVersionPlugin`, qui
 *                                   lit `pkg.version` et remplace le
 *                                   `__APP_VERSION__` de `public/sw.js`)
 *
 * LES DEUX SE BUMPENT ENSEMBLE, MÊME VALEUR, MÊME COMMIT. Bumper celui-ci seul
 * n'invalide AUCUN cache : c'est exactement l'erreur du commit `75b6c477e`
 * (2026-05-02), fait pour purger le cache après un correctif invisible en
 * production — il n'a touché que ce fichier, donc il n'a pas purgé une ligne.
 * L'écart qui a suivi (0.2.1 ici, 0.2.0 dans `package.json`) a vécu 130 jours
 * sans que rien ne le voie.
 *
 * Le gardien `scripts/verify-version-coherence.sh` compare désormais les deux.
 *
 * Le bump est écrit par `.agent/workflows/release-notes-expert.md`, en même
 * temps que la note de version, et jamais séparément.
 */
export const APP_VERSION = '1.1.0'
